module.exports = __webpack_public_path__ + "img/SK36819638.f26b830f.png";